export let deferredPromptA2hsBanner;

window.addEventListener('beforeinstallprompt', function(event) {
    console.log('インストールバナーの表示をキャンセル');
    event.preventDefault();
    deferredPromptA2hsBanner = event;
});

// saveButton.addEventListener('click', function() {
//     if (deferredPrompt !== undefined) {
//       deferredPrompt.prompt();
//       deferredPrompt.userChoice.then(function(result) {
//         if (result.outcome == 'dismissed') {
//           console.log('キャンセルされました');
//         } else {
//           console.log('インストールされました');
//         }
//         deferredPrompt = null;
//         saveButton.addAttribute('disabled');
//       });
//     }
//   });